import { ref, useCssModule, computed } from "vue";
import { u as useI18n } from "./assets/index-CgZzOVq6.js";
import "vue-demi";
import { u as useDataTestIdProp } from "./assets/index-BNd8MWnO.js";
import { u as useDisabledProp } from "./assets/index-DKxr0Yto.js";
import { u as useInputProps } from "./assets/SingleMessage-Dv2wNb7f.js";
import "./assets/index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import XFormField from "./XFormField.js";
import { X as XIcon } from "./assets/XIcon-U9bwokTN.js";
import XButton from "./XButton.js";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "vue-i18n";
import "./locales.js";
import "./assets/index-Df_FM1j-.js";
import "./assets/index-4vIud5LZ.js";
import "./XLink.js";
import "./assets/BaseLink-KuovKwoP.js";
import "./assets/index-Ca8wHgNc.js";
import "./XTooltip.js";
import "./assets/XDropdown-Bc_0Fycm.js";
import "@floating-ui/dom";
import "./BasicContent.js";
import "./ContentBox.js";
import "./CloseButton.js";
import "./AdvancedContent.js";
import "./MessagesContainer.js";
import "@fortawesome/vue-fontawesome";
import "./assets/index-D0Qy8ijJ.js";
import "./XSpinner.js";
const XFileInput$1 = "_XFileInput_pgt54_1";
const inputLabel = "_inputLabel_pgt54_4";
const style0 = {
  XFileInput: XFileInput$1,
  inputLabel
};
const { createDisabledProp, getDisabledClass } = useDisabledProp();
const { createTestIdProp, setupTestId } = useDataTestIdProp();
const {
  createMessageProps,
  createAdditionalMessagesProp,
  createInputProps,
  createLabelProps,
  createRequiredProp
} = useInputProps();
const { t } = useI18n();
const PLACEHOLDER = () => t("ds.XFileInput.placeholder");
const __default__ = {
  name: "XFileInput",
  components: { XFormField, XIcon, XButton },
  inheritAttrs: false
};
const _sfc_main = Object.assign(__default__, {
  props: {
    accept: {
      type: String,
      default: ""
    },
    multiple: {
      type: Boolean,
      default: false
    },
    hideIcon: {
      type: Boolean,
      default: false
    },
    ...createLabelProps(),
    ...createRequiredProp(),
    ...createInputProps({
      placeholder: PLACEHOLDER
    }),
    ...createDisabledProp(),
    ...createMessageProps(),
    ...createAdditionalMessagesProp(),
    ...createTestIdProp()
  },
  emits: ["input"],
  setup(__props, { emit }) {
    const props = __props;
    const hasError = ref(null);
    const inputFileLabelRef = ref(null);
    const { formatTestId } = setupTestId(props);
    const $style = useCssModule();
    const { disabledClass } = getDisabledClass(props);
    const errorClass = computed(() => ({
      [$style.hasError]: hasError.value
    }));
    const fieldClasses = computed(() => ({
      ...errorClass.value,
      ...disabledClass.value
    }));
    function handleError(event) {
      hasError.value = event;
    }
    function handleInputFile(event) {
      emit("input", event);
    }
    function handleFileUpload() {
      inputFileLabelRef.value.click();
    }
    return { __sfc: true, createDisabledProp, getDisabledClass, createTestIdProp, setupTestId, createMessageProps, createAdditionalMessagesProp, createInputProps, createLabelProps, createRequiredProp, t, PLACEHOLDER, props, emit, hasError, inputFileLabelRef, formatTestId, $style, disabledClass, errorClass, fieldClasses, handleError, handleInputFile, handleFileUpload, XFormField, XIcon, XButton };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.XFormField, _vm._b({ class: [_setup.$style.XFileInput, _setup.fieldClasses], attrs: { "data-testid": _setup.formatTestId("field") }, on: { "error": _setup.handleError }, scopedSlots: _vm._u([{ key: "default", fn: function({ uuid }) {
    return [_c("label", { ref: "inputFileLabelRef", class: _setup.$style.inputLabel, attrs: { "for": uuid, "data-testid": _setup.formatTestId("label") } }, [_c("input", { attrs: { "id": uuid, "type": "file", "hidden": "", "disabled": _vm.disabled, "name": _vm.name, "accept": _vm.accept, "multiple": _vm.multiple, "required": _vm.required, "data-testid": _setup.formatTestId() }, domProps: { "value": _vm.value }, on: { "change": _setup.handleInputFile } })]), _vm._t("default", function() {
      return [_c(_setup.XButton, { attrs: { "data-testid": _setup.formatTestId("button") }, on: { "click": _setup.handleFileUpload } }, [!_vm.hideIcon ? _c(_setup.XIcon, { attrs: { "icon": "upload", "left": "", "data-testid": _setup.formatTestId("icon") } }) : _vm._e(), _vm._v(" " + _vm._s(_vm.placeholder) + " ")], 1)];
    }, { "handleFileUpload": _setup.handleFileUpload })];
  } }], null, true) }, "XFormField", { ..._vm.$props, ..._vm.$attrs }, false));
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const XFileInput = __component__.exports;
export {
  PLACEHOLDER,
  XFileInput as default
};
